import styled from 'styled-components';

import OccupancyInput from './OccupancyInput';

const StyledOccupancyInput = styled(OccupancyInput)`
    position: relative;
    border-width: 0;
    border-radius: ${(props) => props.theme.corners.full}px;
    background-color: ${(props) =>
        props.backgroundColor ?? props.theme.colours.white};
    color: ${(props) => props.theme.colours.grey};
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 5.6rem;
    width: 100%;

    &__label {
        width: 100%;
        font-family: 'Quicksand', sans-serif;
        font-weight: 500;
        font-size: 18px;
        display: block;
        overflow: hidden;
        cursor: pointer;
    }

    .icon-container {
        position: absolute;
        z-index: 100;
        font-size: 2rem;
        font-variant: normal;
        line-height: 1;
        speak: none;
        text-transform: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        top: 50%;
        transform: translateY(-50%);
        left: 1.8rem;
    }

    .input-container {
        padding-left: 5rem;
    }
`;

export default StyledOccupancyInput;
